module.exports = __webpack_public_path__ + "img/744.8f9b4179.jpg";